// client/src/components/Sponsors.jsx

const Sponsors = () => {
  return (
    <section
      className="w3-container w3-center"
      id="sponsors"
      style={{ padding: "0 0 64px 0", background: "#f5f5f5" }}
    >
      {/* Inner container */}
      <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
        {/* Divider */}
        <hr
          style={{
            width: "100%",
            margin: "0 auto 40px",
            border: "0",
            borderTop: "1px solid #ddd",
          }}
        />

        <h2 className="w3-text-teal">Yhteistyökumppanit</h2>
        <p>Yhteistyössä toimintaamme tukemassa</p>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "32px",
          }}
        >
          <a
            href="https://vbo.fi"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Varuboden-Osla yhteistyökumppani"
            style={{
              textDecoration: "none",
              color: "inherit",
            }}
          >
            {/* Sponsor card */}
            <div
              className="w3-card"
              style={{
                padding: "30px 40px",
                borderRadius: "12px",
                transition: "transform 0.2s ease, box-shadow 0.2s ease",
                cursor: "pointer",
                background: "#fff",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "scale(1.05)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "";
              }}
            >
              <img
                src="/images/sponsors/S_VARUBODEN-OSLA.svg"
                alt="Varuboden-Osla yhteistyökumppani"
                style={{
                  maxWidth: "180px",
                  width: "100%",
                  height: "auto",
                }}
              />

              <p
                className="w3-small w3-text-grey"
                style={{ marginTop: "12px" }}
              >
                Pääyhteistyökumppani 2026
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Sponsors;
